import axios from '@axios'

const PREFIX = '/importacao-registros'

export default {
  // uploadFile now accepts an optional onProgress callback so the caller
  // (typically a Vue component) can receive upload percentage updates.
  uploadFile(tipoEntidade, file, onProgress) {
    return axios.post(`${PREFIX}/upload?tipoEntidade=${tipoEntidade}`, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: progressEvent => {
        if (progressEvent.lengthComputable) {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          if (typeof onProgress === 'function') onProgress(percent)
        }
      },
    })
  },
  getCamposEntidade(tipoEntidade) {
    return axios.get(`${PREFIX}/campos-recurso?chaveEntidade=${tipoEntidade}`)
  },
  // Lista de tipos de entidade que podem ser importados.
  // Endpoint sugerido: GET /importacao-registros/tipos-entidade
  // Espera-se que o backend retorne um array de TipoEntidadeDTO
  // (por exemplo { Key, Label }). O componente chamador é responsável
  // por normalizar o formato para { value, text } se necessário.
  getTipoEntidadeOptions() {
    return axios.get(`${PREFIX}/tipos-entidade`)
  },
  confirmImport(payload) {
    return axios.post(`${PREFIX}/importar`, payload)
  },
  // Reprocessar uma importação existente -> POST /{id}/reprocessar
  reprocessar(id) {
    if (id === undefined || id === null) throw new Error('id é obrigatório para reprocessar')
    return axios.post(`${PREFIX}/${id}/reprocessar`)
  },

  // Obter status de uma importação -> GET /{id}/status
  getStatus(id) {
    if (id === undefined || id === null) throw new Error('id é obrigatório para obter status')
    return axios.get(`${PREFIX}/${id}/status`)
  },

  // Obter detalhes de uma importação -> GET /{id}/detalhes
  getDetalhes(id) {
    if (id === undefined || id === null) throw new Error('id é obrigatório para obter detalhes')
    return axios.get(`${PREFIX}/${id}/detalhes`)
  },

  // Listar histórico de importações (paged) -> GET /historico?page=&pageSize=
  listHistoricoImportacoes(page = 1, pageSize = 20) {
    return axios.get(`${PREFIX}/historico`, { params: { page, pageSize } })
  },

  // Cancelar importação -> POST /{id}/cancelar
  cancelarImportacao(id) {
    if (id === undefined || id === null) throw new Error('id é obrigatório para cancelar')
    return axios.post(`${PREFIX}/${id}/cancelar`)
  },
}
